import React, { ReactNode, useMemo, useState } from 'react';
import { OpenedLayerResult } from './layers';

export interface Layers {
  layers: OpenedLayerResult[];
  openLayer: (layer: OpenedLayerResult) => void;
  closeLayer: (id: string) => void;
  isLayerOpen: (id: string) => boolean;
}

export const LayerContext = React.createContext<Layers>({
  layers: [],
  openLayer: (layer: OpenedLayerResult) => { console.log(layer) },
  closeLayer: (id: string) => { console.log(id) },
  isLayerOpen:  (id: string) => { return Boolean(id) }
});

export const LayerContextProvider = ({ children }: { children?: ReactNode }) => {

  const [ layers, setLayers ] = useState<Layers["layers"]>([]);

  const openLayer = (layer: OpenedLayerResult) => {
    const updatedLayers = [...layers, layer];
    setLayers(updatedLayers);
  };

  const closeLayer = (id: string) => {
    const updatedLayers = layers.filter(x => x.id !== id);
    setLayers(updatedLayers);
  };

  const isLayerOpen = (id: string) => {
    return Boolean(layers.filter(x => x.id === id).length);
  };

  const LayerContextValue = useMemo(() => ({
    layers,
    openLayer,
    closeLayer,
    isLayerOpen
  }), [layers, openLayer, closeLayer, isLayerOpen]);

  return (
    <LayerContext.Provider value={LayerContextValue}>
      { children }
    </LayerContext.Provider>
  );
};
